import { render, staticRenderFns } from "./NotificationRequestDialog.vue?vue&type=template&id=ec25b64c&scoped=true&"
import script from "./NotificationRequestDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationRequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationRequestDialog.vue?vue&type=style&index=0&id=ec25b64c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec25b64c",
  null
  
)

export default component.exports